import { Reducer } from 'react';
import { negate } from 'lodash/fp';
import { LicenseAction } from '../../../../../types/__generated__/graphql';

export interface LicenseUpdate {
  productFamilyId: number;
  productCurriculumId: number;
  action: LicenseAction;
}

export enum ActionType {
  ADD_UPDATES = 'ADD_UPDATES'
}

interface AddUpdatesAction {
  type: ActionType.ADD_UPDATES;
  payload: {
    action: LicenseAction;
    productFamilyId: number;
    productCurriculumIds: number[];
  };
}

type Action = AddUpdatesAction;

const isSameCurriculum = (first: LicenseUpdate) => (second: LicenseUpdate) => {
  return (
    first.productFamilyId === second.productFamilyId &&
    first.productCurriculumId === second.productCurriculumId
  );
};

const addUpdate = (existingUpdates: LicenseUpdate[], newUpdate: LicenseUpdate) => {
  const existing = existingUpdates.find(isSameCurriculum(newUpdate));

  if (existing && existing.action !== newUpdate.action) {
    return existingUpdates.filter(negate(isSameCurriculum(existing)));
  }

  const updates = existingUpdates.filter(
    u => u.productFamilyId !== newUpdate.productFamilyId || u.action !== newUpdate.action
  );

  return [...updates, newUpdate];
};

const reducer: Reducer<LicenseUpdate[], Action> = (
  state: LicenseUpdate[],
  { type, payload }: Action
) => {
  switch (type) {
    case ActionType.ADD_UPDATES: {
      const { action, productFamilyId, productCurriculumIds } = payload;
      const updates = productCurriculumIds.map(productCurriculumId => ({
        action,
        productFamilyId,
        productCurriculumId
      }));

      return updates.reduce(addUpdate, state);
    }
    default: {
      return state;
    }
  }
};

export default reducer;
